import _ from 'lodash';

import { CASE_DOCUMENT_PREVIEW } from '../actions/actionTypes';

const initialState = {
  isLoading: true,
  isDownloading: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CASE_DOCUMENT_PREVIEW.FETCH.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CASE_DOCUMENT_PREVIEW.FETCH.SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case CASE_DOCUMENT_PREVIEW.FETCH.ERROR:
      return {
        ...state,
        isLoading: false,
        error: _.get(action, ['payload', 'error']),
      };
    case CASE_DOCUMENT_PREVIEW.DOWNLOAD.REQUEST:
      return {
        ...state,
        isDownloading: true,
      };
    case CASE_DOCUMENT_PREVIEW.DOWNLOAD.SUCCESS:
    case CASE_DOCUMENT_PREVIEW.DOWNLOAD.ERROR:
      return {
        ...state,
        isDownloading: false,
      };
    case CASE_DOCUMENT_PREVIEW.CLEAR:
      return initialState;
    default:
      return state;
  }
}
